export class LanguageDataObject {
	/**
	 * @param {string} id - ID of the language in the database provided by the API.
	 * @param {string} name - Language display name from the GUI locale list 'name' property or API if GUI locale is not 
	 * defined for this language.
	 * @param {string} localeCode - Locale code used by the app (Uses IETF BCP 47 language tag) consisting of (ex:
	 * 'sr-Latn-BA', 'sr-Cyrl-RS', 'en-US'):
	 * 	- lowercase, two-letter ISO 639-1 code (ex: 'sr'),
	 * 	- [optional] Title Case ISO 15924 script name (ex: 'Latin'),
	 * 	- [optional] UPPERCASE two-letter ISO 3166-1 alpha-2 country code (ex: 'RS')
	 * @param {string} [countryCode='xx'] - ISO 3166-1 alpha-2 two-letter uppercase country code (ex: 'RS').
	 * @param {boolean} inactive - Flag that specifies if the language is not active in the API.
	 */
	constructor(id, name, localeCode, countryCode = 'xx', inactive) {
		this.id = id;
		this.name = name;
		this.localeCode = localeCode;
		this.countryCode = countryCode;
		this.inactive = inactive;
	}
}